<div class="whiteWrapper" *ngIf="stats?.voting as voting">
  <div class="container whiteBox valignhelper">
    <ng-container *ngIf="showProgressBar; else noProgressBar">
      <div *ngIf="voting.current as c">Die nächste Start-up Arena steht an. Sie entscheiden, welche Start-ups pitchen dürfen!</div>

      <div style="margin-top: 1.5rem">
        <markant-button [routerLink]="votingRoute">Jetzt abstimmen</markant-button>
      </div>
      <div class="voting-progress">
        <div class="passed" [ngStyle]="{width: votePassedPercentage + '%'}"></div>
        <div class="info">Abstimmung endet in {{ remainingDaysToVote }} Tagen</div>
        <div class="end">
          {{ voting.current.votingEnd | moment: 'date' }}
        </div>
      </div>
    </ng-container>
    <ng-template #noProgressBar>
      <div style="margin-top: 1rem" *ngIf="voting.next as c">
        Die nächste Start-up Arena findet am <strong>{{ c.pitchDate | moment: 'date' }} in {{ c.location }}</strong> statt. Sie entscheiden, welche Start-ups
        pitchen dürfen! Ab dem <strong>{{ c.votingStart | moment: 'date' }}</strong> können Sie an der Abstimmung teilnehmen.
      </div>
    </ng-template>
  </div>
</div>

<div class="pruneWrapper">
  <div class="container startups">
    <h2>Die neuesten Start-ups bei voilà!</h2>
    <app-new-products *ngIf="stats" [cycle]="stats.recentCycle.uuid" [statusIn]="['approved', 'invited', 'notinvited']"></app-new-products>
  </div>
</div>

<div class="blueWrapper">
  <div class="container">
    <h2>Das ist voilà! – die Start-up-Arena</h2>
    <div>
      <p>
        Der Handel ist ständig auf der Suche nach neuen, innovativen Produkten und Trends. Um die Markant-Händler und die Start-ups schnell und zielführend
        zusammenzubringen ist voilà! Die Start-up Arena entstanden.
      </p>

      <p>
        Über voilà! – die Start-up-Arena, bündelt und akquiriert die Markant interessante Start-ups und stellt diese den Händlern vor. Die Plattform wird
        regelmäßig um neue Start-ups erweitert.
      </p>

      <p>Sie kennen weitere Start-ups? Machen Sie diese gerne auf voilà! – die Start-up-Arena aufmerksam.</p>
    </div>
  </div>
</div>

<div class="pruneWrapper contacts section">
  <div class="container font">
    <h2 id="teamHeader">Das voilà! Team</h2>
    <br />
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <img src="./assets/img/voila-team.webp" style="max-width: 100%" alt="Voila Team" />
        <div id="teamPictureDescription">
          Wir sind das Team hinter voilà! – die Start-up-Arena:<br />
          Alicia, Isabel, Jessica und Jaqueline (v. l. n. r.)
        </div>
      </div>
      <div class="col-sm-12 col-md-6">
        {{ this.dasTeamText }}
        <strong><a href="mailto:startups@de.markant.com"> startups&#64;de.markant.com</a> </strong>
        <br />
      </div>
    </div>
  </div>
</div>
